export const billingKeys = {
  all: ['billing'] as const,
  statements: () => [...billingKeys.all, 'statements'] as const,
  statementList: (filters?: Record<string, string>) =>
    [...billingKeys.statements(), 'list', filters ?? {}] as const,
  // LR-557: the counterparty's period document, addressed by any member
  // statement id. One cache entry per ADDRESSED id: an expand warms the page
  // opened by the same statement id (and vice versa), but a sibling statement
  // of the same document is a different key and fetches its own copy.
  statementDocument: (id: number) =>
    [...billingKeys.statements(), 'document', id] as const,
  accruals: () => [...billingKeys.all, 'accruals'] as const,
  accrualList: (filters?: Record<string, string>) =>
    [...billingKeys.accruals(), 'list', filters ?? {}] as const,
  preview: () => [...billingKeys.all, 'preview'] as const,
  previewFor: (params?: Record<string, string | number>) =>
    [...billingKeys.preview(), params ?? {}] as const,
  // LR-571: one position's daily lines, which the documents above no longer
  // carry. `scope` is what makes two reads of the same position different
  // ledgers (which statement, or which preview slice). Keyed per position rather
  // than per section on purpose: the endpoint answers with EVERY section of the
  // position, so a security footed under two headings is one fetch, not two.
  positionRows: (scope: string, positionId: number) =>
    [...billingKeys.all, 'position-rows', scope, positionId] as const,
  adjustments: () => [...billingKeys.all, 'adjustments'] as const,
  adjustmentList: (filters?: Record<string, string>) =>
    [...billingKeys.adjustments(), 'list', filters ?? {}] as const,
  adjustmentTradeOptions: (filters?: Record<string, string>) =>
    [...billingKeys.adjustments(), 'trade-options', filters ?? {}] as const,
  // LR-728: one background export, polled until it ends.
  exportJob: (id: number) => [...billingKeys.all, 'export-job', id] as const,
} as const;
